import { NavLink } from 'react-router-dom'

import { Link } from '@buffer-mono/popcorn'

import type { ConnectedApp } from '../../../shared/hooks/useConnectedApps'
import { SettingsRow } from '../../../shared/components/SettingsRow'

import type { JSX } from 'react'

export const ConnectedSection = ({
  connections,
}: {
  connections: ConnectedApp[]
}): JSX.Element | null => {
  if (connections.length === 0) {
    return null
  }

  return (
    <SettingsRow id="connected-integrations">
      <SettingsRow.Header>
        <SettingsRow.Title>Connected</SettingsRow.Title>
        <SettingsRow.Description>
          {connections.length} connection
          {connections.length === 1 ? '' : 's'}
        </SettingsRow.Description>
      </SettingsRow.Header>
      <SettingsRow.Control>
        <Link as={NavLink} to="/settings/api">
          Manage connections
        </Link>
      </SettingsRow.Control>
    </SettingsRow>
  )
}
